<template>
  <div class='upload-settle-container' style='display: inline'>
    <el-upload
      ref='upload'
      :show-file-list='false'
      :disabled='upload.loading'
      :data='{proj_id:settlementId}'
      :headers='upload.header'
      :before-upload='importBefore'
      :on-change='importChange'
      :on-success='importSuccess'
      action='/admin_api/settle_proj_detail/parse_import'
      style='display: inline;margin-left: 10px;'
    >
      <el-button type='primary' icon='el-icon-upload2'>导入进度表</el-button>
    </el-upload>

    <el-dialog custom-class='dialog-preview' :title='`导入预览【${upload.file_name}】`'
               :visible.sync='dialogUploadList' :close-on-click-modal='false' :close-on-press-escape='false'
               :show-close='importObj.status!==MapStatus.DOING' center width='90%'>
      <div class='main'>
        <div class='left'>
          <div class='line' />
          <el-table :key='tableKey' :data='tableData' border size='mini' height='380px' :row-style='styleTableRow'>
            <el-table-column label='序号' width='50'>
              <template slot-scope='{$index}'>{{ $index + 1 }}</template>
            </el-table-column>
            <el-table-column prop='kol_nickname' label='博主昵称' width='130' />
            <el-table-column prop='pay_amount' label='应付款' width='70' />
            <el-table-column prop='month' label='月份' width='70' />
            <el-table-column prop='platform' label='平台' width='100' />
            <el-table-column prop='organ_name' label='所属机构' width='100' />
            <el-table-column prop='company' label='公司全称' width='100' />
            <el-table-column prop='koc_cost_price' label='KOC成本价' width='100' />
            <el-table-column prop='sale_price' label='对外价(含税)' width='100' />
            <el-table-column prop='remark' label='备注' />
            <el-table-column prop='order_no' label='订单号' width='120' />
          </el-table>
        </div>
        <div class='right'>
          <div class='line' />
          <div class='content'>
            <div style='text-align: center;font-weight: bold;margin-bottom: 20px;'>
              {{ hasError ? 'Excel数据不完善' : 'Excel数据' }}
            </div>
            <template v-if='importObj.status===MapStatus.WAIT'>
              <!--       等待上传       -->
              <div v-if='hasError' class='error'>
                <!--       Excel数据异常       -->
                <div v-for='(err,field) in tableDataError' :key='field' style='margin-bottom: 8px;'>
                  <div class='title'>1. {{ MapRequiredFields[field] }}必填</div>
                  <div class='desc'>{{ '\u3000' }}第 {{ err.join('、') }} 行{{ MapRequiredFields[field] }}不能为空</div>
                </div>
              </div>
              <template v-else>
                <!--       Excel数据准备导入       -->
                <div class='statistic'>
                  <div>总计 <span>{{ tableData.length }}</span> 条</div>
                  <div>未开始导入<br />当前进度0%</div>
                  <el-progress type='circle' :percentage='importObj.progress' style='margin-top: 30px;'
                               color='#FF3176' />
                </div>
              </template>
            </template>
            <template v-else>
              <!--       Excel导入       -->
              <div class='statistic'>
                <div>总计 <span>{{ tableData.length }}</span> 条</div>
                <div>未导入 <span>{{ tableData.length - importObj.num_success }}</span> 条</div>
                <div>成功导入 <span class='success'>{{ importObj.num_success }}</span> 条</div>
                <div>导入失败 <span class='fail'>{{ importObj.num_fail }}</span> 条</div>
                <el-progress type='circle' :percentage='importObj.progress' style='margin-top: 30px;' color='#FF3176' />
              </div>
            </template>
          </div>
        </div>
      </div>
      <span slot='footer' class='dialog-footer'>
        <template v-if='importObj.status!==MapStatus.DONE'>
          <template v-if='hasError'>
            <el-upload
              :show-file-list='false'
              :disabled='upload.loading'
              :data='{proj_id:settlementId}'
              :headers='upload.header'
              :before-upload='importBefore'
              :on-change='importChange'
              :on-success='importSuccess'
              action='/admin_api/settle_proj_detail/parse_import'
              style='display: inline;margin-left: 10px;'
            >
              <el-button type='primary'>重新上传</el-button>
            </el-upload>
          </template>
          <template v-else>
            <el-button v-if='importObj.status===MapStatus.WAIT' @click='dialogUploadList = false'>取消导入</el-button>
            <el-button :loading='loadingSure' type='primary' @click='handelSure'>确定导入</el-button>
          </template>
        </template>
        <el-button v-else type='primary' @click='dialogUploadList = false'>导入结束</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getToken } from '@/utils/auth'

const MapRequiredFields = { kol_nickname: '博主昵称', pay_amount: '应付款' }
const ModelUpload = {
  header: { 'HYPERF-SESSION-ID': getToken() },
  loading: false,
  file: [],
  file_name: ''
}
const MapStatus = {
  WAIT: 'WAIT',
  DOING: 'DOING',
  DONE: 'DONE'
}
const ModelImport = {
  status: MapStatus.WAIT,
  num_success: 0,
  num_fail: 0,
  progress: 0
}

export default {
  name: 'UploadSettle',
  props: {
    settlementId: {
      type: [Number, String],
      required: true
    }
  },
  data() {
    return {
      MapStatus,
      MapRequiredFields,
      loadingFullscreen: false,
      loadingSure: false,
      hasError: false,
      importObj: { ...{}, ...ModelImport },
      tableKey: new Date().getTime(),
      tableData: [],
      tableDataError: {},
      dialogUploadList: false,
      upload: { ...{}, ...ModelUpload }
    }
  },
  watch: {
    'importObj.num_success'(_) {
      const total = this.tableData.length || 0
      this.importObj.progress = total ? parseInt((_ * 100 / total) + '') : 0
    },
    dialogUploadList(_) {
      if (!_) {
        this.$emit('success')
      }
    }
  },
  created() {
  },
  methods: {
    async handelSure() {
      const _this = this
      _this.loadingSure = true
      _this.importObj.status = MapStatus.DOING
      for (let datumIndex = 0; datumIndex < _this.tableData.length; datumIndex++) {
        const datum = _this.tableData[datumIndex]
        datum.project_id = _this.settlementId
        const response = await _this.$api.settlementPlanSaveImport(datum)
        if (response && response.id) {
          _this.importObj.num_success++
          datum.import = 'success'
        } else {
          datum.import = 'fail'
        }
      }
      _this.importObj.status = MapStatus.DONE
      _this.importObj.num_fail = _this.tableData.length - _this.importObj.num_success
      _this.$message.info('导入结束！')
      _this.tableKey = new Date().getTime()
      _this.loadingSure = false
    },
    styleTableRow({ row }) {
      if (row.import === 'fail') {
        return {
          backgroundColor: '#FFF',
          color: '#fe2d54'
        }
      }
    },
    importBefore() {
      // console.log('importBefore')
    },
    importChange(file) {
      if (file.status !== 'ready') {
        return
      }
      this.loadingFullscreen = this.$loading({
        lock: true,
        text: '解析文件中...请稍后',
        spinner: 'el-icon-loading',
        background: 'rgba(255, 255, 255, 0.7)'
      })
      this.tableData = []
      this.importObj = { ...{}, ...ModelImport }
      this.upload = { ...{}, ...ModelUpload }
      this.upload.file = [file]
      this.upload.file_name = file.name
    },
    importSuccess(response) {
      if (response.code !== 200) {
        this.$notify.error(response.msg)
        return
      }
      this.tableData = response.data || []
      this.checkExcel()
      this.dialogUploadList = true
      this.loadingFullscreen && this.loadingFullscreen.close()
    },
    checkExcel() {
      const tableDataError = {}
      let hasError = false
      for (const field in MapRequiredFields) {
        this.tableData.map((datum, datumIndex) => {
          datum.import = 'wait'
          if (!datum[field]) {
            hasError = true
            if (tableDataError[field] === undefined) {
              tableDataError[field] = []
            }
            tableDataError[field].push((datumIndex + 1))
          }
        })
      }
      this.tableDataError = tableDataError
      this.hasError = hasError
    }
  }
}
</script>

<style lang='scss'>
.upload-settle-container {
  @font-face {
    font-family: 'FjallaOne-Regular';
    src: url("~@/assets/font/FjallaOne-Regular.ttf");
  }
  font-family: FjallaOne-Regular, DINPro Medium, sans-serif !important;

  .dialog-preview {
    .el-dialog__body {
      padding: 10px 25px 30px;
    }

    .main {
      display: flex;
      justify-content: space-between;
      width: 100%;

      .left {
        width: calc(100% - 180px);
      }

      .statistic {
        text-align: center;
        line-height: 1.5;

        span {
          font-size: 18px;
          font-weight: bold;
        }

        .success {
          color: darkgreen;
        }

        .fail {
          color: #fe2d54;
        }
      }


      .line {
        height: 10px;
        border-radius: 10px 10px 0 0;
        background: #FF3176;
      }

      .right {
        width: 160px;
        margin-left: 20px;

        .content {
          border: 1px solid #EBEEF5;
          height: calc(100% - 28px);
          padding: 8px;

          .error {
            height: 324px;
            overflow-y: auto;
          }

          .title {
            font-size: 14px;
          }

          .desc {
            color: #909399;
            margin-top: 2px;
          }
        }
      }
    }
  }
}
</style>
